import Repository from "./Repository";
import EmployeeGroup from "../types/EmployeeGroup";
import BaseResponse from "../types/BaseResponse";
import Axios from "axios";

const resource = "/employeeGroup";

export default {
  get() {
    return Repository.get(`${resource}`);
  },
  getByCompany(companyId: string) {
    return Repository.get(`${resource}/company/${companyId}`);
  },
  groupsByCompanyWithDetails(companyId: string) {
    return Repository.get<BaseResponse<EmployeeGroup[]>>(
      `${resource}/company/${companyId}/details`
    );
  },
  groupsByEmployee(employeeId: string) {
    return Repository.get(`${resource}/byEmployee/${employeeId}`);
  },
  getOne(id: string) {
    return Repository.get<BaseResponse<EmployeeGroup>>(`${resource}/${id}`);
  },
  save(employeeGroup: EmployeeGroup) {
    if (employeeGroup.employeeGroupId) {
      return Repository.patch<BaseResponse<EmployeeGroup>>(
        `${resource}`,
        employeeGroup
      );
    } else {
      return Repository.post<BaseResponse<EmployeeGroup>>(
        `${resource}`,
        employeeGroup
      );
    }
  },
  saveAll(employeeGroups: EmployeeGroup[]) {
    return Axios.all(employeeGroups.map((group) => this.save(group)));
  },
  delete(groupId: string) {
    return Repository.delete(`${resource}/${groupId}`);
  },
  deleteGroupFromEmployee(employeeId: string, groupId: string) {
    return Repository.delete(`${resource}/${groupId}/${employeeId}`);
  },
  getTypes(companyId: string) {
    return Repository.get(`${resource}/${companyId}/groupTypes`);
  },
  copyGroups(companyId: string, templateCompanyId: string) {
    return Repository.get(
      `${resource}/${companyId}/copyGroups/${templateCompanyId}`
    );
  },
  deleteAll(companyId: string) {
    return Repository.delete(`${resource}/deleteAll/${companyId}`);
  },
  addEmployeeToGroup(
    companyId: string,
    employeeId: string,
    employeeGroupId: string
  ) {
    return Repository.post(`${resource}/${employeeGroupId}/addEmployee`, {
      companyId,
      employeeGroupId,
      employeeId,
    });
  },
  addEmployeeListToGroup(
    companyId: string,
    employeeGroupId: string,
    employeeIds: Array<string>
  ) {
    return Repository.post(`${resource}/addEmployeeList`, {
      companyId,
      employeeGroupId,
      employeeIds,
    });
  },
  removeEmployeesFromGroup(
    companyId: string,
    employeeGroupId: string,
    employeeIds: Array<string>
  ) {
    return Repository.post(`${resource}/removeEmployees`, {
      companyId,
      employeeGroupId,
      employeeIds,
    });
  },

  getByEmployee(employeeId: string) {
    return Repository.get(`${resource}/byEmployee/${employeeId}`);
  },
  getEmployeesByGroup(companyId: string, groupId: string) {
    return Repository.get(`${resource}/${companyId}/${groupId}`);
  },
  addManagerToGroups(groupManager: string, employeeGroupIds: string[]) {
    return Repository.post(`${resource}/employeeGroupManager`, {
      groupManager,
      employeeGroupIds,
    });
  },
  saveAssignments(
    employeeId: string,
    companyId: string,
    originalGroupIdList: string[],
    newGroupIdList: string[]
  ) {
    return Repository.patch(`${resource}/employee/${employeeId}`, {
      oldEmployeeGroupList: originalGroupIdList,
      newEmployeeGroupList: newGroupIdList,
      companyId,
    });
  },
  getManagedByEmployee(employeeId: string) {
    return Repository.get<BaseResponse<EmployeeGroup[]>>(
      `${resource}/managedByEmployee/${employeeId}`
    );
  },
};
